/**
 * Constantes para el módulo de Clientes
 */

export const CLIENT_FIELDS = [
  { name: "name", label: "Nombre" },
  { name: "contactName", label: "Nombre del contacto" },
  { name: "email", label: "Email" },
  { name: "phone", label: "Teléfono" },
];

